import { render, staticRenderFns } from "./input-switch.vue?vue&type=template&id=a8d04f4c&"
import script from "./input-switch.vue?vue&type=script&lang=js&"
export * from "./input-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports